import {
  ACCEPT_TERMS_AND_CONDITIONS,
  BACK_TO_IDENTIFIER_FORM,
  CONFIRM_USER_SIGNUP,
  DROP_SESSION,
  ENTER_TEMPORARY_PASSWORD,
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  RESET_ALL_AUTH_ERROR_MESSAGES,
  RESET_AUTH_ERROR_MESSAGE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  SET_NEW_PASSWORD,
  SHOW_AUTH_VALIDATION_ERROR_MESSAGE,
  SHOW_MESSAGE,
  SHOW_TERMS_AND_CONDITIONS,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  SUBMIT_TEMPORARY_PASSWORD,
  VERIFY_USER,
  VERIFY_USER_SUCCESS,
  VERIFY_USER_SIGNUP,
  VERIFY_USER_SIGNUP_SUCCESS,
} from '../constants/ActionTypes';

export const acceptTermsAndConditions = (accessToken, version) => ({
  type: ACCEPT_TERMS_AND_CONDITIONS,
  payload: { accessToken, version },
});

export const backToIdentifierForm = () => ({
  type: BACK_TO_IDENTIFIER_FORM,
});

export const confirmUserSignUp = (identifier, password, code) => ({
  type: CONFIRM_USER_SIGNUP,
  payload: { identifier, password, code },
});

export const dropSession = () => ({
  type: DROP_SESSION,
});

export const enterTemporaryPassword = accessToken => ({
  type: ENTER_TEMPORARY_PASSWORD,
  payload: { accessToken },
});

export const hideAuthLoader = () => ({
  type: ON_HIDE_LOADER,
});

export const hideMessage = () => ({
  type: HIDE_MESSAGE,
});

export const resetAllAuthErrorMessages = () => ({
  type: RESET_ALL_AUTH_ERROR_MESSAGES,
});

export const resetAuthErrorMessage = (messageType = '') => ({
  type: RESET_AUTH_ERROR_MESSAGE,
  payload: { messageType },
});

export const setInitUrl = url => ({
  type: INIT_URL,
  payload: url,
});

export const showAuthLoader = () => ({
  type: ON_SHOW_LOADER,
});

export const showAuthMessage = message => ({
  type: SHOW_MESSAGE,
  payload: message,
});

export const showAuthValidationErrorMessage = (type, message) => ({
  type: SHOW_AUTH_VALIDATION_ERROR_MESSAGE,
  payload: { type, message },
});

export const showTermsAndConditions = (accessToken, termsAndConditionsText, version) => ({
  type: SHOW_TERMS_AND_CONDITIONS,
  payload: { accessToken, termsAndConditionsText, version },
});

export const signInSuccess = accessToken => ({
  type: SIGNIN_USER_SUCCESS,
  payload: { accessToken },
});

export const submitTemporaryPassword = (accessToken, temporaryPassword) => ({
  type: SUBMIT_TEMPORARY_PASSWORD,
  payload: { accessToken, temporaryPassword },
});

export const userResetPassword = login => ({
  type: RESET_PASSWORD,
  payload: { login },
});

export const userResetPasswordStatus = (status = null) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: { status },
});

export const userSetNewPassword = (login, code, password) => ({
  type: SET_NEW_PASSWORD,
  payload: { login, code, password },
});

export const userSignIn = (identifier, password) => ({
  type: SIGNIN_USER,
  payload: { identifier, password },
});

export const userSignOut = () => ({
  type: SIGNOUT_USER,
});

export const userSignOutSuccess = () => ({
  type: SIGNOUT_USER_SUCCESS,
});

export const userSignUp = user => ({
  type: SIGNUP_USER,
  payload: user,
});

export const userSignUpSuccess = authUser => ({
  type: SIGNUP_USER_SUCCESS,
  payload: authUser,
});

export const verifyUser = identifier => ({
  type: VERIFY_USER,
  payload: { identifier },
});

export const verifyUserSignUp = (identifier, code) => ({
  type: VERIFY_USER_SIGNUP,
  payload: { identifier, code },
});

export const verifyUserSignUpSuccess = () => ({
  type: VERIFY_USER_SIGNUP_SUCCESS,
});

export const verifyUserSuccess = registered => ({
  type: VERIFY_USER_SUCCESS,
  payload: registered,
});
